module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('header', {
    class: {
      active: _vm.fixed
    }
  }, [(_vm.left != 'false') ? _c('i', {
    staticClass: "iconfont icon-fanhui",
    on: {
      "click": _vm.back
    }
  }) : _vm._e(), _vm._v(" "), (_vm.title != 'false') ? _c('h1', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm._t("content"), _vm._v(" "), _vm._t("right")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61bb9822"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/Header.vue
// module id = 583
// module chunks = 0